import { Location } from "vue-router";
import router from "@tt-app/router";
import { ROUTES, CONSOLIDATED_EXERCISE_TYPES } from "@tt-app/constants";
import { ExerciseType } from "@tt-app/types";

interface NextExerciseDetails {
  assignmentId?: string;
  courseUuid: string;
  exerciseType?: number;
  type?: number;
  uuid?: string;
}

export const nextExerciseRouter = (nextExerciseDetails: NextExerciseDetails) => {
  let nextRoute: Location;

  const exerciseTypeNumber = nextExerciseDetails.type || nextExerciseDetails.exerciseType;

  if (!nextExerciseDetails.uuid || !exerciseTypeNumber) {
    if (nextExerciseDetails.assignmentId) {
      nextRoute = {
        name: ROUTES.ASSIGNMENT.DETAILS.NAME
      };
    } else {
      nextRoute = {
        name: ROUTES.COURSE.DETAILS.NAME,
        params: {
          courseUuid: nextExerciseDetails.courseUuid
        }
      };
    }
  } else {
    let routeName;

    if (CONSOLIDATED_EXERCISE_TYPES.includes(exerciseTypeNumber)) {
      routeName = ROUTES.EXERCISE.EXERCISE_ROOT.NAME;
    } else {
      const exerciseTypeString = ExerciseType[exerciseTypeNumber];
      routeName = ROUTES.EXERCISE[exerciseTypeString].NAME;
    }

    nextRoute = {
      name: routeName,
      params: {
        courseUuid: nextExerciseDetails.courseUuid,
        exerciseUuid: nextExerciseDetails.uuid
      }
    };
  }

  if (nextExerciseDetails.assignmentId) {
    nextRoute.params = nextRoute.params || {};
    nextRoute.params["assignmentId"] = nextExerciseDetails.assignmentId;
  }

  router.push(nextRoute);
};
